module.exports = {
	bg: {
		messages: {
			_default: (field) => 'Полето не е валидно.',
			after: (field, [target, inclusion]) => `The ${field} must be after ${inclusion ? 'or equal to ' : ''}${target}.`,
			alpha_dash: (field) => 'Полето може да съдържа букви, цифри, тирета и подчертавки.',
			alpha_num: (field) => 'Полето може да съдържа букви и цифри.',
			alpha_spaces: (field) => 'Полето може да съдържа само букви и интервали.',
			alpha: (field) => 'Полето трябва да съдържа само букви.',
			before: (field, [target, inclusion]) => `The ${field} must be before ${inclusion ? 'or equal to ' : ''}${target}.`,
			between: (field, [min, max]) => `Полето трябва да има стойност между ${min} и ${max}.`,
			confirmed: (field) => 'Полето за потвърждение не съвпада.',
			credit_card: (field) => 'Полето не е валидно.',
			date_between: (field, [min, max]) => `Полето трябва да е между ${min} и ${max}.`,
			date_format: (field, [format]) => `Полето трябва да е във формат ${format}.`,
			decimal: (field, [decimals] = ['*']) => `The ${field} must be numeric and may contain ${decimals === '*' ? '' : decimals} decimal points.`,
			digits: (field, [length]) => `Полето трябва да съдържа само ${length} на брой цифри.`,
			dimensions: (field, [width, height]) => `The ${field} must be ${width} pixels by ${height} pixels.`,
			email: (field) => 'Моля, въведете валиден email адрес.',
			ext: (field) => `The ${field} must be a valid file.`,
			image: (field) => `The ${field} must be an image.`,
			in: (field) => `The ${field} must be a valid value.`,
			ip: (field) => 'Полето трябва да е валиден IP адрес.',
			max: (field, [length]) => `The ${field} may not be greater than ${length} characters.`,
			max_value: (field, [max]) => `The ${field} must be ${max} or less.`,
			mimes: (field) => `The ${field} must have a valid file type.`,
			min: (field, [length]) => `The ${field} must be at least ${length} characters.`,
			min_value: (field, [min]) => `The ${field} must be ${min} or more.`,
			not_in: (field) => `The ${field} must be a valid value.`,
			numeric: (field) => 'Полето трябва да съдържа само цифри.',
			regex: (field) => `The ${field} format is invalid.`,
			required: (field) => 'Полето е задължително.',
			size: (field, [size]) => `The ${field} must be less than ${size} KB.`,
			url: (field) => `The ${field} is not a valid URL.`
		}
	}
};



// WEBPACK FOOTER //
// ./src/lang/validator_bg.js